<div class="add-dialog appt-decline-dailog">
  <div class="ui-g">
    <div class="ui-g-12 p-zero dialog-header">
      <div class="header-bar flex-start-center">
        <div class="center-bar">
          <div class="heading-box">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
        </div>
        <div class="width-45">
          <i class="fal fa-times fa-sm ml-15 dialog-close" id="close-dialog-icon" (click)="close()"></i>
        </div>
      </div>
    </div>

    <div class="ui-g-12 dialog-body">
      <div class="decline-body">
        <h3>Decline appointment request</h3>

        <div class="form-group">
          <div class="form-text">Reason for declining request (for office use)</div>
          <textarea class="form-control" placeholder="Notes" [value]="declineRequestObj.declineReason"
            (change)="handleRadioChange('declineReason',$event.target.value)"></textarea>
        </div>

        <div class="db-question">
          <p>Do you want to send a message to the requester?</p>
          <div class="db-ans">
            <app-radio-button label="Yes" [selectedValue]="declineRequestObj.isSendMsg" [value]="true"
              (appChange)="handleRadioChange('isSendMsg',$event)" style="margin-top: 10px;"></app-radio-button>

            <app-radio-button label="No" [selectedValue]="declineRequestObj.isSendMsg" [value]="false"
              (appChange)="handleRadioChange('isSendMsg',$event)" style="margin-top: 10px;"></app-radio-button>
          </div>
        </div>

        <ng-container *ngIf="declineRequestObj && declineRequestObj.isSendMsg">
          <div class="db-question">
            <p>Send message via</p>

            <div class="db-ans">
              <app-checkbox label="SMS" (appChange)="handleRadioChange('isSms',$event)"></app-checkbox>
              <app-checkbox label="Email" (appChange)="handleRadioChange('isEmail',$event)"></app-checkbox>
            </div>
          </div>

          <div class="form-group">
            <textarea class="form-control" [value]="declineRequestObj.template"
              (change)="changeTemplate($event)"></textarea>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="ui-g-12 text-right dialog-footer">
      <button class="btn btn-border pointer btn-submit mr-2" id="btn-cancel" (click)="close()">Cancel</button>
      <button class="btn revert-btn btn-submit" id="btn-save" [disabled]="isProcessing" (click)="declineRequest()">
        <span>Decline</span>
        <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i>
      </button>
    </div>
  </div>
</div>
